import { flatMap } from 'lodash';
import { useProjectTemplateSpaces } from './use-get-all-spaces';
export const useProjectTemplateSpaceTabs = ()=>{
    const spaces = useProjectTemplateSpaces();
    const spaceTabs = flatMap(Object.values(spaces).map((space)=>space.spaceTabs));
    return spaceTabs;
};
export const useProjectTemplateSpaceIds = (projTemplateId)=>{
    const spaces = Object.values(useProjectTemplateSpaces());
    const arrayOfDocIds = [];
    spaces.forEach((x)=>{
        x.spaceTabs.forEach((y)=>{
            arrayOfDocIds.push(y.spaceTabId);
        });
    });
    arrayOfDocIds.push(projTemplateId);
    return arrayOfDocIds;
};
